<template>
  <!-- 元素格子 -->
  <div class>
    <div
      style="width: 40px;height: 45px;padding: 5px;border-radius: 4px;border: 1px solid #999;cursor: pointer;display: flex;flex-direction: column; margin: 0 2px;"
      :class="element && element.disable ? 'disable' : (element &&element.isChoose ? 'choose' : element && element.class)"
      @click="choose"
      v-if="!isNum && !isText"
    >
      <div class="element_top">
        <div class="element_index">{{element ? element.index : ''}}</div>
        <div class="element_code">{{element ? element.code : ''}}</div>
      </div>
      <div class="element_content">{{element ? element.name : ''}}</div>
    </div>
    <div
      style="width: 40px;height: 45px;padding: 5px;border-radius: 4px;border: 1px solid #FFF;cursor: pointer;display: flex;flex-direction: column; margin: 0 2px;"
      @click="choose"
      v-if="isNum"
    >
      <div class="element_top"></div>
      <div class="element_num" v-if="isNum">
        <!-- {{num}} -->
      </div>
    </div>
    <div
      style="width: 40px;height: 45px;padding: 5px;border-radius: 4px;border: 1px solid #FFF;cursor: pointer;display: flex;flex-direction: column; margin: 0 2px;"
      :class="element ? element.class : ''"
      @click="choose"
      v-if="isText"
    >
      <div class="element_top"></div>
      <div class="element_text" v-if="isText">{{text}}</div>
    </div>
  </div>
</template>

<script>
/**
 * element {Object} 元素对象 包括 名字、质量、电子等基本信息
 * elemeny.isChoose {Boolean} 是否被选中  true 是 false 否
 * elemeny.disable {Boolean} 是否被禁用  true 是 false 否
 * isNum {Boolean} 是否是上方的数字 不可点击
 * num {Number} 数字的值
 * isText {Boolean} 是否是文字内容 例如镧系 不可点击
 * text {String} 文字
 * @updateList {Function} 点击事件触发父组件的方法
 */
export default {
  props: {
    element: {
      type: Object,
      default: () => {}
    },
    isNum: {
      type: Boolean,
      default: false
    },
    num: {
      type: Number,
      default: 0
    },
    isText: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ""
    }
  },
  methods: {
    choose() {
      if (this.element && this.element.disable || this.element.isNeed) {
        return;
      } else {
        if (this.element) {
          this.element.isChoose = !this.element.isChoose;
        }
        this.$emit("updateList", this.element);
      }
    }
  }
};
</script>

<style lang="scss">
.element {
  width: 18%;
  height: 70px;
  padding: 5px;
  border-radius: 4px;
  border: 1px solid #999;
  cursor: pointer;
  display: flex;
  flex-direction: column;
}

.element_top {
  height: 20px;
  display: flex;
  line-height: 20px;
  justify-content: space-between;
  color: #444444;
  font-size: 12px;
}

.element_content {
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #444444;
  text-align: center;
  font-size: 16px;
}
.element_num {
  // width: 62px !important;
  display: flex;
  justify-content: center;
  line-height: 100px;
  color: #444444;
  text-align: center;
  font-size: 14px;
}
.element_text {
  display: flex;
  justify-content: center;
  line-height: 65px;
  color: #444444;
  text-align: center;
  font-size: 16px;
}

.non-metals {
  background-color: #bdfff8;
}

.noble-gases {
  background-color: #f7cef6;
}

.halogens {
  background-color: #d2bafa;
}

.alkalai-metals {
  background-color: #ffa8a5;
}

.alkaline-earths {
  background-color: #ffba6c;
}

.transition-metals {
  background-color: #fffaae;
}

.other-metals {
  background-color: #a2eaab;
}

.semi-metals {
  background-color: #c7fdba;
}

.lanthanides {
  background-color: #fdc0a4;
}

.actinides {
  background-color: #fee1be;
}

.uncategorized {
  background-color: #e3e3e3;
}
.choose {
  background-color: #4c68da;
}
.disable {
  background-color: #cccccc;
}
.none_emelemt {
  border: 1px solid #fff !important;
}
.none_emelemt_text {
  border: 1px solid #fff !important;
}
</style>